export const rtiTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ './en.json').then(translations => ({
      en: translations.default,
    })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
  sv: () => import('./sv.json').then(translations => ({ sv: translations.default })),
  fi: () => import('./fi.json').then(translations => ({ fi: translations.default })),
};
